import { PublicationShortname } from "@src/app/auth/serviceIdentifier";

type PublicationOverride = {
  enabled?: boolean;
  nlb?: boolean;
};

type NewOnboardingConfig = {
  enabled: boolean;
  enabledForNlb: boolean;
  overrides: Partial<Record<PublicationShortname, PublicationOverride>>;
};

export const newOnboardingConfig: NewOnboardingConfig = {
  enabled: true, // Master switch
  enabledForNlb: false, // NLB users see old modal

  overrides: {
    [PublicationShortname.ST]: { enabled: false },
  },
};

/**
 * Determines whether to show the new onboarding overlay.
 *
 * Logic cascade:
 * 1. Check master switch (enabled) - if false, return false
 * 2. Check publication override - if exists, use it
 * 3. If no override - use global defaults
 *
 * @param publicationId - The current publication
 * @param isNlbUser - Whether the user is an NLB user
 * @returns boolean - Whether to show the new onboarding
 */
export function shouldShowNewOnboarding(
  publicationId: PublicationShortname | null,
  isNlbUser: boolean,
): boolean {
  // Master switch
  if (!newOnboardingConfig.enabled) return false;

  // No publication ID
  if (!publicationId) return false;

  const override = newOnboardingConfig.overrides[publicationId];

  // Check if publication is explicitly disabled
  if (override?.enabled === false) return false;

  // Check NLB user
  if (isNlbUser) {
    // Use override if exists, otherwise use global default
    return override?.nlb ?? newOnboardingConfig.enabledForNlb;
  }

  return true;
}
